import fetch from 'auth/FetchInterceptor'

const whatsappService = {}

whatsappService.all = function () {
  return fetch({
    url: '/whatsapp/all',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

whatsappService.paginated = function ({ page = 0, size = 10, celular = '' } = {}) {
  return fetch({
    url: '/whatsapp',
    method: 'get',
    params: { page, size, celular },
  })
}

whatsappService.obterConfiguracao = function () {
  return fetch({
    url: '/empresa/configuracao-whatsapp',
    method: 'get',
  })
}

whatsappService.salvarConfiguracao = function (data) {
  return fetch({
    url: '/empresa/configuracao-whatsapp',
    method: 'put',
    data,
  })
}

whatsappService.enviarIndividual = function (data) {
  return fetch({
    url: '/whatsapp/envio-individual',
    method: 'post',
    data,
  })
}

whatsappService.boletosCliente = function (clienteId) {
  return fetch({
    url: `/whatsapp/envio-individual/boletos/${clienteId}`,
    method: 'get',
  })
}

export default whatsappService